import { useAuth } from "@/features/auth";
import { useDossierId } from "@/features/dossier-details";
import { DossierTraceIdContext } from "@/shared/hooks/use-dossier-trace-id.tsx";
import { generateTraceId, trackRouteChange } from "@/shared/utils";
import { PropsWithChildren, useEffect, useMemo } from "react";

export function DossierTraceProvider({ children }: PropsWithChildren) {
    const id = useDossierId();
    const { apiDomain } = useAuth();
    const pathname = location.pathname;

    const traceId = useMemo(() => {
        // traceId stays stable per dossierId
        // if `id` is undefined, a trace id will be generated that's stable until id is defined
        return generateTraceId();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        // track the route change and make sure all subsequent logs use the trace id for this dossier
        trackRouteChange(pathname, apiDomain, traceId);
    }, [apiDomain, pathname, traceId]);

    return <DossierTraceIdContext value={{ traceId }}>{children}</DossierTraceIdContext>;
}
